export default {"src":"/_next/static/media/0xfd282f16a64c6d304ac05d1a58da15bed0467c71.9ba33f5c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};